import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { StoreContext } from "shared/context/store-context";

import ItemHeader from "layouts/ItemHeader";
import { days, days_en } from "shared/util/types";
import { getCurrentLanguage } from "shared/utility/lang";

const ShiftInfo = ({ shift, date, onClose }) => {
  const { t } = useTranslation();
  const { schoolOptions } = useContext(StoreContext);
  const language = getCurrentLanguage();
  const dayList = language === "en" ? days_en : days;

  return (
    <React.Fragment>
      {shift && (
        <ItemHeader onClose={onClose}>
          <h4 style={{ margin: "0px" }}>
            {t("shiftAnalyzer.shiftOf", { label: schoolOptions.find((option) => option.value === shift.school.toString()).label })}
          </h4>
          <span>
            <strong>{t("shiftAnalyzer.date")}</strong> {date}
          </span>
          <span>
            <strong>{t("shiftAnalyzer.dayLabel")}</strong> {dayList.find((day) => day.value.toString() === shift.day.toString()).label}
          </span>
          <span>
            <strong>{t("shiftAnalyzer.shiftLabel")}</strong> {shift.name} ({shift.description})
          </span>

          <span>
            <strong>{t("shiftAnalyzer.serviceArrivalForShiftStart")}</strong> {shift.serviceArrivalTime}
          </span>
          <span>
            <strong>{t("shiftAnalyzer.serviceDepartureForShiftEnd")}</strong> {shift.serviceLeaveTime}
          </span>
        </ItemHeader>
      )}
    </React.Fragment>
  );
};

export default ShiftInfo;
